import { error as logError } from '../utils/logger'
import { apiUrl } from '../config/config'
import { sendRequest } from '../utils/FetchServices'

interface PropsGetRanking {
    authToken: string
    retries?: number
    timeout?: number
}

export const request_get_ranking = async ({ authToken, retries = 2, timeout = 10 }: PropsGetRanking) => {
    const URL = apiUrl + '/oneapp/get_ranking'
    try {
        const headers = {
            Authorization: authToken,
        }
        const data = await sendRequest(URL, 'GET', headers, null, retries, timeout)

        return data.response
    } catch (error) {
    logError('RankingService', 'request_get_games failed', error)
        return null
    }
}
